/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProductDesignCollection,
    MelcoFusionModelsCustomProductDesignCollectionFromJSON,
    MelcoFusionModelsCustomProductDesignCollectionFromJSONTyped,
    MelcoFusionModelsCustomProductDesignCollectionToJSON,
    MelcoFusionModelsCustomProductDesignHoop,
    MelcoFusionModelsCustomProductDesignHoopFromJSON,
    MelcoFusionModelsCustomProductDesignHoopFromJSONTyped,
    MelcoFusionModelsCustomProductDesignHoopToJSON,
    MelcoFusionModelsRendererMatrix,
    MelcoFusionModelsRendererMatrixFromJSON,
    MelcoFusionModelsRendererMatrixFromJSONTyped,
    MelcoFusionModelsRendererMatrixToJSON,
    MelcoFusionModelsRendererRect,
    MelcoFusionModelsRendererRectFromJSON,
    MelcoFusionModelsRendererRectFromJSONTyped,
    MelcoFusionModelsRendererRectToJSON,
    MelcoModelsDesign,
    MelcoModelsDesignFromJSON,
    MelcoModelsDesignFromJSONTyped,
    MelcoModelsDesignToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProductImageDesign
 */
export interface MelcoFusionModelsCustomProductImageDesign {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    personalization_id?: string | null;
    /**
     * 
     * @type {MelcoFusionModelsRendererRect}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    renderer_rect?: MelcoFusionModelsRendererRect;
    /**
     * 
     * @type {MelcoFusionModelsRendererMatrix}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    renderer_matrix?: MelcoFusionModelsRendererMatrix;
    /**
     * 
     * @type {MelcoModelsDesign}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    design?: MelcoModelsDesign;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    production_rotation_degree?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    production_instructions?: string | null;
    /**
     * 
     * @type {MelcoFusionModelsCustomProductDesignCollection}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    design_collection?: MelcoFusionModelsCustomProductDesignCollection;
    /**
     * 
     * @type {MelcoFusionModelsCustomProductDesignHoop}
     * @memberof MelcoFusionModelsCustomProductImageDesign
     */
    hoop?: MelcoFusionModelsCustomProductDesignHoop;
}

export function MelcoFusionModelsCustomProductImageDesignFromJSON(json: any): MelcoFusionModelsCustomProductImageDesign {
    return MelcoFusionModelsCustomProductImageDesignFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductImageDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProductImageDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personalization_id': !exists(json, 'personalization_id') ? undefined : json['personalization_id'],
        'renderer_rect': !exists(json, 'renderer_rect') ? undefined : MelcoFusionModelsRendererRectFromJSON(json['renderer_rect']),
        'renderer_matrix': !exists(json, 'renderer_matrix') ? undefined : MelcoFusionModelsRendererMatrixFromJSON(json['renderer_matrix']),
        'design': !exists(json, 'design') ? undefined : MelcoModelsDesignFromJSON(json['design']),
        'production_rotation_degree': !exists(json, 'production_rotation_degree') ? undefined : json['production_rotation_degree'],
        'production_instructions': !exists(json, 'production_instructions') ? undefined : json['production_instructions'],
        'design_collection': !exists(json, 'design_collection') ? undefined : MelcoFusionModelsCustomProductDesignCollectionFromJSON(json['design_collection']),
        'hoop': !exists(json, 'hoop') ? undefined : MelcoFusionModelsCustomProductDesignHoopFromJSON(json['hoop']),
    };
}

export function MelcoFusionModelsCustomProductImageDesignToJSON(value?: MelcoFusionModelsCustomProductImageDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'personalization_id': value.personalization_id,
        'renderer_rect': MelcoFusionModelsRendererRectToJSON(value.renderer_rect),
        'renderer_matrix': MelcoFusionModelsRendererMatrixToJSON(value.renderer_matrix),
        'design': MelcoModelsDesignToJSON(value.design),
        'production_rotation_degree': value.production_rotation_degree,
        'production_instructions': value.production_instructions,
        'design_collection': MelcoFusionModelsCustomProductDesignCollectionToJSON(value.design_collection),
        'hoop': MelcoFusionModelsCustomProductDesignHoopToJSON(value.hoop),
    };
}


